//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { theme } from '@/tailwind.config.js'

gsap.registerPlugin(ScrollTrigger)

export default {

  props: {
    title: {
      type: String,
      required: true
    },
    activeVariantSku: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    products: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      animate: false,
      observer: null
    }
  },

  computed: {
    getBreakpoint () {
      return {
        md: window.matchMedia(`(min-width: ${theme.extend.screens.md})`),
        xl: window.matchMedia(`(min-width: ${theme.extend.screens.xl})`)
      }
    },
    skuImage () {
      return this.getImageSrc(this.activeVariantSku)
    }
  },

  mounted () {
    this.addBreakpointListener()

    // Preload product images off the main thread
    setTimeout(this.preloadProductImages, 0)
  },

  beforeDestroy () {
    this.removeBreakpointListener()
  },

  methods: {
    addBreakpointListener () {
      this.initAnimation()

      if (this.getBreakpoint.md.addEventListener) this.getBreakpoint.md.addEventListener('change', this.resetAnimation)
      else this.getBreakpoint.md.addListener(this.resetAnimation)

      if (this.getBreakpoint.xl.addEventListener) this.getBreakpoint.xl.addEventListener('change', this.resetAnimation)
      else this.getBreakpoint.xl.addListener(this.resetAnimation)
    },

    removeBreakpointListener () {
      if (this.getBreakpoint.md.removeEventListener) this.getBreakpoint.md.removeEventListener('change', this.resetAnimation)
      else this.getBreakpoint.md.removeListener(this.resetAnimation)

      if (this.getBreakpoint.xl.removeEventListener) this.getBreakpoint.xl.removeEventListener('change', this.resetAnimation)
      else this.getBreakpoint.xl.removeListener(this.resetAnimation)
    },

    resetAnimation () {
      this.destroyAnimation()
      this.initAnimation()
    },

    initialSetUpAnimation () {
      if (this.$refs.heroProductContent) gsap.set(this.$refs.heroProductContent, { opacity: 0 })
    },

    destroyAnimation () {
      if (this.tlheroProductMedia) {
        this.tlheroProductMedia.kill(true)
        gsap.set(this.$refs.heroProductBlock, { clearProps: true })
        gsap.set(this.$refs.heroProductMedia, { clearProps: true })
        gsap.set(this.$refs.heroProductImage, { clearProps: true })
      }

      if (this.tlHeroHeading) {
        this.tlHeroHeading.kill(true)
        gsap.set(this.$refs.heroHeading, { clearProps: true })
      }

      if (this.tlHeroProductContent) {
        this.tlHeroProductContent.kill(true)
        gsap.set(this.$refs.heroProductContent, { clearProps: true })
      }
    },

    initAnimation () {
      this.initialSetUpAnimation()

      let scrollTriggerEndHeading = 'bottom 15%'
      if (this.getBreakpoint.xl.matches) scrollTriggerEndHeading = '95% top'
      else if (this.getBreakpoint.md.matches) scrollTriggerEndHeading = '95% top'

      let heroProductBlockY = 0
      if (this.getBreakpoint.xl.matches) heroProductBlockY = '-19vh'
      else if (this.getBreakpoint.md.matches) heroProductBlockY = '-19vh'

      let heroProductMediaX = 0
      if (this.getBreakpoint.xl.matches) heroProductMediaX = '47.5%'
      else if (this.getBreakpoint.md.matches) heroProductMediaX = '110%'

      let heroProductMediaY = '-110%'
      if (this.getBreakpoint.xl.matches) heroProductMediaY = '-50%'
      else if (this.getBreakpoint.md.matches) heroProductMediaY = '-50%'

      let heroProductImageY = 0
      if (this.getBreakpoint.xl.matches) heroProductImageY = '-31%'
      else if (this.getBreakpoint.md.matches) heroProductImageY = '-75%'

      let heroProductImageScale = 1.25
      if (this.getBreakpoint.xl.matches) heroProductImageScale = 1
      else if (this.getBreakpoint.md.matches) heroProductImageScale = 1.5

      this.tlheroProductMedia = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: this.$refs.heroHeading,
          start: 'top top',
          end: scrollTriggerEndHeading,
          scrub: true,
          id: 'tlheroProductMedia'
          // markers: true
        }
      })
      this.tlheroProductMedia
        .from(this.$refs.heroProductBlock, {
          y: heroProductBlockY,
          z: 0
        })
        .from(this.$refs.heroProductMedia, {
          x: heroProductMediaX,
          y: heroProductMediaY,
          z: 0
        }, '<')
        .from(this.$refs.heroProductImage, {
          y: heroProductImageY,
          z: 0,
          rotation: -25,
          scale: heroProductImageScale
        }, '<')

      this.tlHeroHeading = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: this.$refs.heroHeading,
          start: 'top top',
          end: 'bottom center',
          scrub: true,
          id: 'tlHeroHeading'
          // markers: true
        }
      })
      this.tlHeroHeading
        .to(this.$refs.heroHeading, {
          opacity: 0,
          y: this.getBreakpoint.md.matches ? 0 : '25%',
          z: 0
        })

      this.tlHeroProductContent = gsap.timeline({
        defaults: {
          duration: 1,
          ease: 'none'
        },
        scrollTrigger: {
          trigger: this.$refs.productSection,
          start: 'top center',
          end: '45% center',
          scrub: true,
          id: 'tlHeroProductContent'
          // markers: true
        }
      })
      this.tlHeroProductContent
        .to(this.$refs.heroProductContent, {
          opacity: 1,
          z: 0
        })
    },

    getImageSrc (sku) {
      return `https://dynamic.sungod.co/?sku=${sku}&image_number=8&scale=1.3&width=900&height=900&c=${this.$config.sha}`
    },

    preloadProductImages () {
      this.products.forEach((product) => {
        const image = new Image()
        image.src = this.getImageSrc(product.sku)
      })
    }
  }
}
